module.exports = __webpack_public_path__ + "img/issue_finished.1b2716a6.svg";